import React, {Component} from 'react'
import '../../styles/Admin.css'
import AdminPanel from "../AdminPanel";

export default class AdminPanelHome extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedItem: '',
            title: '',
            selectedIndex: 0
        }
    }

    render() {
        return <AdminPanel>
            <div className="componentContainer">
                <div className="text-center" style={{paddingTop: 50, paddingBottom: 50}}>
                    <h2 style={{fontWeight: 'bold'}}>Witaj w panelu administacyjnym.</h2>
                    <h5>Z poziomu panelu można zarządzać opcjami i zawartością witryny.</h5>
                </div>
            </div>
        </AdminPanel>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/AdminPanelHome.js